import * as React from 'react';
import { createComponent } from '@lit/react';
import { LoadingInfoWC } from './loading-info.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../../component-types-generics';

export type LoadingInfoProps = GenerateComponentTypeWithChildren<LoadingInfoWC>;

export type LoadingInfoPropsWithRef = GeneratePropsWithRef<LoadingInfoProps>;

export const LoadingInfo = createComponent({
  tagName: LoadingInfoWC.tagname,
  elementClass: LoadingInfoWC,
  react: React,
}) as LoadingInfoPropsWithRef;
